import { Flight } from '@ibe.models/flight.model.lib';


/**
 * State for deeplink price mismatch
 *
 * @export
 * @class State
 */
export class FlightState {
    stage: any;
	flight: Flight;
}

export const initialState: FlightState = {
    stage: null,
    flight: null
};
